import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
    Table,
    Spinner
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as clientAction from "../../../store/Y3JtV2lzZUZvbGxvd3/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import api from "helpers/Api"
import ReactDOM from 'react-dom'
import TabComponent from "./TabComponent"

const CrmWiseFollowupTypeReport = (props) => {
    const { searchBtnStyle, dispatch } = props

    const title = "Crm Wise Followup Type Report"
    const [clientPendingData, setClientPendingData] = useState({
        previousFollowupFromDate: "",
        previousFollowupToDate: "",

    })
    //Fetching API  setClientPendingData clientAction
    useEffect(() => {

        dispatch(clientAction.loadProductStatus())
        dispatch(clientAction.loadRecordsMetaData())
    }, [])

    const sessionUpdate = useSelector((specificstate) => specificstate.session)

    const { user = [] } = sessionUpdate

    //Date format
    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []

    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

    console.log(dateFormat)
    //date format
    const update = useSelector((specificstate) => specificstate.crmWiseFollowupTypeReport)
    //product_data
    const {
        product_data = [],
        recordsMetaData = {} } = update

    //Handle Change

    const [employee, setEmployee] = useState([])

    const handleChange = (e) => {
        setClientPendingData({ ...clientPendingData, [e.target.name]: e.target.value })
    }

    const [downloadLoading, setDownloadLoading] = useState(false)
    //Search value

    const [searchFilter, setSearchFilter] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [btnLoader, setBtnLoader] = useState(false)

    const [searchValue, setSearchValue] = useState({})

    console.log(searchValue)
    const handleFilter = (e) => {
        e.preventDefault()
        var searchEmployee = employee && employee ? employee.value : ""

        var searchFromDate =
            clientPendingData && clientPendingData.previousFollowupFromDate
                ? moment(clientPendingData.previousFollowupFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            clientPendingData && clientPendingData.previousFollowupToDate
                ? moment(clientPendingData.previousFollowupToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}

        if (searchEmployee) {
            searchvalue.crmId = searchEmployee
        }
        if (searchFromDate) {
            searchvalue.previousFollowupFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.previousFollowupToDate = searchToDate
        }


        setSearchValue(searchvalue)
        dispatch(clientAction.loadProductStatus(searchvalue))
        setBtnLoader(true)
        setTimeout(() => {
            setBtnLoader(false)
        }, 3000)


    }

    //reset

    const resetForm = () => {
        setEmployee([])
        setSearchInput("")
        setSearchValue({})
        setClientPendingData({
            ...clientPendingData,
            previousFollowupFromDate: "",
            previousFollowupToDate: "",

        })
        dispatch(clientAction.loadProductStatus({ mode: 1 }))
    }

    // const product_data = [{
    //     "crmId": "64a7a1e1267e9e96ddaf4177",
    //     "crmName": "SARAVANAN",
    //     "count": {
    //         "ALMBUM": 1,
    //         "FRAME": 2,
    //         "RETOUCH": 2,
    //         "ALMBUM PRINT": 5,
    //         "CV SONGS": 0,
    //         "TESTING 1": 0,
    //         "TESTING 2": 56
    //     }
    // },
    // {
    //     "crmId": "64a7a1e1267e9e96ddaf4177",
    //     "crmName": "SARAVANAN",
    //     "count": {
    //         "ALMBUM": 0,
    //         "FRAME": 4,
    //         "RETOUCH": 0,
    //         "ALMBUM PRINT": 0,
    //         "CV SONGS": 6,
    //         "TESTING 1": 0,
    //         "TESTING 2": 0
    //     }
    // }, {
    //     "crmId": "64a7a1e1267e9e96ddaf4177",
    //     "crmName": "SARAVANAN",
    //     "count": {
    //         "ALMBUM": 0,
    //         "FRAME": 0,
    //         "RETOUCH": 1,
    //         "ALMBUM PRINT": 0,
    //         "CV SONGS": 0,
    //         "TESTING 1": 0,
    //         "TESTING 2": 7
    //     }
    // }]

    const handleClickTab = (tableData) => {
        const statusName = tableData.shortName || tableData.shortName
        console.log(tableData, "tabale")


        const statusDetails = {
            crmId: tableData.crmId,
            shortName: tableData.shortName,
            ...(clientPendingData.previousFollowupFromDate ?
                { previousFollowupFromDate: moment(clientPendingData.previousFollowupFromDate).format("YYYY-MM-DD") } : {}),
            ...(clientPendingData.previousFollowupToDate ?
                { previousFollowupToDate: moment(clientPendingData.previousFollowupToDate).format("YYYY-MM-DD") } : {})
        }

        api
            .post(`/deliverable_followup_reason_report_details`, statusDetails)
            .then((response) => {
                const statusData = !isEmpty(response.data.data) ? response.data.data : []
                setTimeout(() => {
                    // Use the current value of statusData, which should be updated due to the useEffect

                    const newTab = window.open("", "_blank", "width=600,height=400")
                    if (newTab) {
                        const container = newTab.document.createElement("div")
                        const fallbackDateFormat = "dd/mm/yyyy"
                        newTab.document.body.appendChild(container)
                        ReactDOM.render(
                            <TabComponent
                                data={statusData} // Use statusData directly here
                                dispatch={dispatch}
                                statusPayload={statusDetails}
                                name={statusName}
                                dateFormat={dateFormat || fallbackDateFormat}
                            />,
                            container
                        )
                        newTab.document.title = "CRM-WISE-PENDING-CLIENT-COUNT"
                    }
                }, 1500)
            })
            .catch((error) => {
                Promise.reject(error)
                const newTab = window.open("", "_blank", "width=600,height=400")
                if (newTab) {
                    const container = newTab.document.createElement("div")
                    newTab.document.body.appendChild(container)
                    ReactDOM.render(
                        <TabComponent
                            data={[]} // Use statusData directly here
                            dispatch={dispatch}
                            statusPayload={statusDetails}
                            name={statusName}
                            dateFormat={dateFormat}
                        />,
                        container
                    )
                    newTab.document.title = "CRM-WISE-PENDING-CLIENT-COUNT"
                }
            })
    }



    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)
        dispatch(clientAction.loadProductStatus({
            searchFilter: searchInput,

        }))
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    // dynamic headers for table
    const headers = !isEmpty(product_data) && product_data[0].count ? product_data[0].count : {}
    const headersValue = !isEmpty(headers)
        ? Object.entries(headers).filter(([key,]) => key !== "crmName" && key !== "crmId")
        : []

    const filteredHeadersObject = Object.fromEntries(headersValue)
    //export csv 
    const exportToCsv = () => {
        var searchEmployee = employee && employee ? employee.value : ""

        var searchFromDate =
            clientPendingData && clientPendingData.previousFollowupFromDate
                ? moment(clientPendingData.previousFollowupFromDate).format("YYYY-MM-DD")
                : ""
        var searchToDate =
            clientPendingData && clientPendingData.previousFollowupToDate
                ? moment(clientPendingData.previousFollowupToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}

        if (searchEmployee) {
            searchvalue.crmId = searchEmployee
        }
        if (searchFromDate) {
            searchvalue.previousFollowupFromDate = searchFromDate
        }
        if (searchToDate) {
            searchvalue.previousFollowupToDate = searchToDate
        }

        setDownloadLoading(true)

        api
            .post(`/deliverable_followup_reason_report`, searchvalue)
            .then((response) => {
                //  console.log(response)
                const data = response.data.data || []
                //  const data = product_data
                if (isEmpty(data)) {
                    setDownloadLoading(false)
                    return
                }

                const dynamicHeaders = Object.keys(data[0].count)

                let headerData = [
                    `S.No,CRM Name,${dynamicHeaders.join(",")},Row Total`,
                ]

                // Calculate rows and row-wise totals
                const usersCsv = data.map((row, index) => {
                    const dynamicValues = dynamicHeaders.map((key) => {
                        const value = parseFloat(row.count[key]) || 0
                        return value
                    })

                    // Calculate row-wise total
                    const rowTotal = dynamicValues.reduce((sum, value) => sum + value, 0)

                    // Generate CSV row
                    return `${index + 1},${row.crmName || "--"},${dynamicValues.join(
                        ","
                    )},${rowTotal}`
                })

                // Calculate column-wise totals
                const columnTotals = dynamicHeaders.map((key) => {
                    return data.reduce((sum, row) => {
                        const value = parseFloat(row.count[key]) || 0
                        return sum + value
                    }, 0)
                })

                // Calculate the total of all row-wise totals
                const totalOfRowTotals = columnTotals.reduce((sum, value) => sum + value, 0)

                // Generate column totals row
                const totalsRow = `,Column Total,${columnTotals.join(",")},${totalOfRowTotals}`

                setTimeout(() => {
                    downloadFile({
                        data: [...headerData, ...usersCsv, totalsRow].join("\n"),
                        fileName: "CrmWiseFollowupTypeReport.csv",
                        fileType: "text/csv",
                    })
                    setDownloadLoading(false)
                }, 1000)
            })
            .catch((error) => {
                if (error) {
                    setDownloadLoading(false)
                }
            })
    }



    return (
        <div className="page-content">
            <MetaTags>
                <title>{title} | Zero Gravity CRM</title>
            </MetaTags>
            <Container fluid>
                <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                <form>
                                    <Row>


                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event From Date"}
                                                >
                                                    {"Previous Followup From Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="previousFollowupFromDate"
                                                value={clientPendingData.previousFollowupFromDate}
                                                max={clientPendingData.previousFollowupToDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>

                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <div className="d-flex justify-content-between">
                                                <Label
                                                    className={"form-label"}
                                                    htmlFor={"Event To Date"}
                                                >
                                                    {"Previous Followup To Date"}
                                                </Label>
                                            </div>
                                            <Input
                                                type="date"
                                                name="previousFollowupToDate"
                                                value={clientPendingData.previousFollowupToDate}
                                                min={clientPendingData.previousFollowupFromDate}
                                                onChange={(e) => handleChange(e)}
                                                placeholder="Enter "
                                            />
                                        </Col>
                                        <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                            <Label className="employee-label">Crm Name</Label>
                                            <Select
                                                type="text"
                                                name="employee"
                                                //  isMulti
                                                value={employee}
                                                onChange={(e) => setEmployee(e)}
                                                options={
                                                    recordsMetaData ? recordsMetaData.employeeOptions : []
                                                }
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        zIndex: 10,
                                                    }),
                                                }}
                                                placeholder="Select Crm Name"
                                                classNamePrefix="select2-selection"
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                                            <div
                                                className="filter-buttons"
                                                style={{ float: "right" }}
                                            >
                                                <Button
                                                    type="button"
                                                    className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                                                    onClick={() => {
                                                        resetForm()
                                                    }}
                                                >
                                                    <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                    Reset
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    onClick={(e) => handleFilter(e)}
                                                    className="btn btn-success btn-label simple-form-applyfilter-btn"
                                                >
                                                    <i className="bx bx-filter-alt label-icon"></i>
                                                    {btnLoader && btnLoader ? (
                                                        <ButtonSpinner />
                                                    ) : (
                                                        "Apply Filter"
                                                    )}{" "}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md="12" lg="12" xl="12">
                        <Card>
                            <CardBody>

                                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <form onSubmit={handleClick} className="d-flex flex-row">
                                            <div style={searchBtnStyle || null}>
                                                <Input
                                                    type="text"
                                                    name="searchInput"
                                                    value={searchInput}
                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Search"
                                                    style={{ position: "relative" }}
                                                />
                                                <i
                                                    className="bx bx-search-alt"
                                                    style={{
                                                        position: "absolute",
                                                        top: "54px",
                                                        left: "41px",
                                                        fontSize: "13px",
                                                    }}
                                                />
                                            </div>

                                            <button
                                                className="btn btn-success mx-2"
                                                type="submit"
                                                style={{
                                                    background: searchFilter ? "#2ca67a" : "",
                                                    color: searchFilter ? "#ffffff" : "",
                                                }}
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </form>
                                    </div>

                                </div>
                                <Row>
                                    <Col md="4" lg="4" sm="12"></Col>
                                    <Col md="8" lg="8" sm="12" style={{ marginBottom: "20px", marginTop: "-41px" }}>
                                        <div
                                            style={{
                                                float: "right",
                                            }}
                                        >
                                            <Button
                                                className="btn btn-primary"
                                                onClick={exportToCsv}
                                                id="download"
                                                style={{
                                                    backgroundColor: "#e40d8c",
                                                    color: "white",
                                                    border: "none",
                                                }}
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    </Col></Row>

                                <Col md="12" lg="12" xl="12" className="mt-3">
                                    <Table responsive bordered>
                                        <thead>
                                            <tr>

                                                <th style={{ minWidth: "100px", position: "sticky", left: 0, zIndex: 1, backgroundColor: "#F8F8FB" }}>{"CRM Name"}</th>
                                                {Object.keys(filteredHeadersObject).map((key, index) => (
                                                    <th key={index} style={{ minWidth: "100px", textAlign: "center" }}>
                                                        {key}
                                                    </th>
                                                ))}
                                                <th style={{ textAlign: "center", fontWeight: "bold" }}>Total</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            {!isEmpty(product_data) ? product_data.map((data, index) => {
                                                const rowTotal = Object.keys(filteredHeadersObject).reduce(
                                                    (sum, key) => sum + (parseFloat(data.count[key]) || 0),
                                                    0
                                                )
                                                return (
                                                    <tr key={index}>

                                                        <td style={{ minWidth: "100px", position: "sticky", left: 0, zIndex: 1, backgroundColor: "#F8F8FB" }}>
                                                            {data.crmName || "--"}</td>
                                                        {Object.keys(filteredHeadersObject).map((key, idx) => {
                                                            const tableData = {
                                                                crmName: data.crmName,
                                                                crmId: data.crmId,
                                                                shortName: key
                                                            }

                                                            return (
                                                                <td
                                                                    key={idx}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        minWidth: "100px",
                                                                        color: "#e40d8c",
                                                                        textDecoration: "underline",
                                                                    }}
                                                                >
                                                                    <div onClick={() => handleClickTab(tableData)}>
                                                                        {data.count[key] !== undefined ? data.count[key] : "--"}
                                                                    </div>
                                                                </td>
                                                            )
                                                        })}
                                                        <td style={{ textAlign: "center", fontWeight: "bold" }}>{rowTotal}</td>
                                                    </tr>)
                                            }) : ""}


                                            <tr>
                                                <td style={{ textAlign: "center", left: 0, fontWeight: "bold", minWidth: "100px", position: "sticky", zIndex: 1, backgroundColor: "#F8F8FB" }}>Column Total</td>
                                                {Object.keys(filteredHeadersObject).map((key, idx) => {
                                                    // Calculate the column total for the `count` object
                                                    const columnTotal = product_data.reduce(
                                                        (sum, data) => sum + (parseFloat(data.count[key]) || 0), // Access `data.count[key]`
                                                        0
                                                    )
                                                    return (
                                                        <td key={idx} style={{ textAlign: "center", fontWeight: "bold" }}>
                                                            {columnTotal}
                                                        </td>
                                                    )
                                                })}
                                                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                                    {/* Calculate the grand total */}
                                                    {product_data.reduce((totalSum, data) => {
                                                        return (
                                                            totalSum +
                                                            Object.keys(filteredHeadersObject).reduce(
                                                                (rowSum, key) => rowSum + (parseFloat(data.count[key]) || 0), // Access `data.count[key]`
                                                                0
                                                            )
                                                        )
                                                    }, 0)}
                                                </td>
                                            </tr>

                                        </tbody>
                                    </Table>
                                    <div className="font-size-14 mt-2">
                                        <p>
                                            {" "}
                                            <p>{`Showing rows ${product_data && product_data.length > 0 ? 1 : 0
                                                } to ${product_data && product_data.length > 0
                                                    ? product_data.length
                                                    : 0
                                                } of ${product_data && product_data.length > 0
                                                    ? product_data.length
                                                    : 0
                                                }`}</p>
                                        </p>
                                    </div>
                                </Col>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {downloadLoading ? (
                <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                >
                    <Modal.Body>
                        <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                        />
                    </Modal.Body>
                </Modal>
            ) : (
                ""
            )}


        </div>
    )
}
CrmWiseFollowupTypeReport.propTypes = {
    dispatch: PropTypes.func,
    searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    // employee: state.employeeRequest.employee,CrmWiseFollowupTypeReport
})
//CrmWiseFollowupTypeReport
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CrmWiseFollowupTypeReport)
)
